<template>
  <el-card
    id="counterWidget"
    class="clear-card counterWidget"
    shadow="hover"
    :body-style="{
      height: 'calc(100% - 56px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }"
  >
    <div
      slot="header"
      class="header"
    >
      <span>{{ label }}</span>
    </div>
    <div class="content">
      <span v-if="value === 0">
        {{ zeroLabel }}
      </span>
      <CountTo
        v-else
        :start-val="0"
        :end-val="value"
        :duration="2000"
      />
      <span v-if="valueTotal > 0">
        / <CountTo
          :start-val="0"
          :end-val="valueTotal"
          :duration="2000"
        />
      </span>
    </div>
  </el-card>
</template>

<script>
import CountTo from 'vue-count-to';

export default {
  components: {
    CountTo,
  },

  props: {
    value: {
      type: Number,
      default: 0,
    },

    valueTotal: {
      type: Number,
      default: 0,
    },

    zeroLabel: {
      type: String,
      default: '0',
    },

    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  #counterWidget {
    box-sizing: border-box;

    .header {
      font-weight: bold;
      text-align: center;
    }

    .content {
      font-weight: bold;
      font-size: 30px;
      text-align: center;
    }
  }
</style>

<style lang="scss">
  #counterWidget {
    .el-card__body {
      box-sizing: border-box;
    }
  }
</style>
